// FeedbackDetailsModal.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Chip,
  Avatar,
  Slide,
  Backdrop,
} from "@mui/material";
import { useMaterialUIController } from "../../context";
import { useTheme } from "@mui/material/styles";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const FeedbackDetailsModal = ({ open, onClose, feedback }) => {
  const [controller] = useMaterialUIController();
    const darkMode = controller.darkMode;
    const theme = useTheme();
  if (!feedback) return null;

  const getStatusColor = (status) => {
    const colors = {
      new: "error",
      in_progress: "warning",
      resolved: "success",
      closed: "default",
    };
    return colors[status] || "default";
  };

  const getStatusLabel = (status) => {
    const labels = {
      new: "جديد",
      in_progress: "قيد المعالجة",
      resolved: "تم الحل",
      closed: "مغلق",
    };
    return labels[status] || status;
  };

  const getPriorityColor = (priority) => {
    const colors = {
      high: "error",
      medium: "warning",
      low: "info",
    };
    return colors[priority] || "default";
  };

  const getPriorityLabel = (priority) => {
    const labels = {
      high: "عالية",
      medium: "متوسطة",
      low: "منخفضة",
    };
    return labels[priority] || priority;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth dir="rtl" 
      TransitionComponent={Transition}
     
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "15vh",
          borderRadius: "16px",
          overflow: "auto", // ✅
          maxHeight: "100vh", // ✅
        },
      }}>
      <DialogContent sx={{  bgcolor: darkMode ? theme.palette.background.default : "background.paper"}}>
      <DialogTitle sx={{ fontWeight: "bold" }}>تفاصيل الشكوى أو الملاحظة</DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2  }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar sx={{ width: 40, height: 40, bgcolor: "#c4a15d" }}>
              {feedback.user.name.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                {feedback.user.name}
              </Typography>
              <Typography variant="body2" color="text.main">
                {feedback.user.email}
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.main">
              العنوان:
            </Typography>
            <Typography variant="body1">{feedback.title}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.main">
              الوصف:
            </Typography>
            <Typography variant="body1">{feedback.description}</Typography>
          </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2  }}>

          <Box>
            <Typography variant="subtitle2" color="text.main">
              النوع:
            </Typography>
            <Chip label={feedback.feedback_type.name} size="small" variant="outlined" sx={{
              color:"text.main", 
              p:2,
            }}/>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.main">
              الحالة:
            </Typography>
            <Chip
              label={getStatusLabel(feedback.status)}
              color={getStatusColor(feedback.status)}
              size="small"
              />
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.main">
              الأولوية:
            </Typography>
            <Chip
              label={getPriorityLabel(feedback.priority)}
              color={getPriorityColor(feedback.priority)}
              size="small"
              />
          </Box>
              </Box>

          <Box>
            <Typography variant="subtitle2" color="text.main">
              تاريخ الإنشاء:
            </Typography>
            <Typography variant="body1">{feedback.created_at}</Typography>
          </Box>
        </Box>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" sx={{
          color:"text.light", bgcolor:"primary.dark" ,"&:hover": {
            color: "text.main",
            bgcolor:"primary.main",
          },
        }}>
          إغلاق
        </Button>
      </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackDetailsModal;
